import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import CategoriesDescription from '~/components/Layout/CategoriesDescription.vue';
import BaseBreadcrumbs from '~/components/Layout/BaseBreadcrumbs.vue';
import BaseSingleBreadcrumb from '~/components/Layout/BaseSingleBreadcrumb.vue';
import TheCategoriesLabels from '~/components/Layout/TheCategoriesLabels.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
export default defineComponent({
  name: 'AppCategoriesHeader',
  components: {
    BaseBreadcrumbs: BaseBreadcrumbs,
    BaseSingleBreadcrumb: BaseSingleBreadcrumb,
    TheCategoriesLabels: TheCategoriesLabels,
    CategoriesDescription: CategoriesDescription,
    AzLoader: AzLoader
  },
  props: {
    type: {
      type: String,
      default: 'plp'
    },
    breadcrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    description: {
      type: [Object, String],
      default: ''
    },
    backgroundImage: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var isEolp = computed(function () {
      return props.type === 'eolp';
    });
    var currentPage = computed(function () {
      var _route$query;
      return Number(route === null || route === void 0 ? void 0 : (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page) || 1;
    });
    var isFirstPage = computed(function () {
      return currentPage.value === 1;
    });
    var isClient = computed(function () {
      return typeof window !== 'undefined';
    });
    var isDescriptionVisible = computed(function () {
      return isClient.value || isFirstPage.value;
    });
    var isResponsive = computed(function () {
      return !!props.backgroundImage;
    });
    var headerDescription = computed(function () {
      return props.description;
    });
    var localImageUrl = computed(function () {
      if (props.backgroundImage) {
        return generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, props.backgroundImage, 1920);
      }
      var localImagePath = require("~/assets/images/banner/banner_".concat(props.type, ".webp")) || '';
      return "url(".concat(localImagePath, ")");
    });
    var computedClass = computed(function () {
      return [props.type, {
        responsive: isResponsive.value
      }];
    });
    return {
      translate: translate,
      isEolp: isEolp,
      localImageUrl: localImageUrl,
      isResponsive: isResponsive,
      headerDescription: headerDescription,
      isDescriptionVisible: isDescriptionVisible,
      isMobile: isMobile,
      computedClass: computedClass
    };
  }
});